import { cn } from "@design-system/lib/utils";
import { Link, useLocation } from "@remix-run/react";
import { useHomeNavigationLinks } from "../../../hooks/use-home-navigation-links.hook";

export function HeaderHomeSwitcher({
  mobile = false,
  onNavigate,
}: {
  mobile?: boolean;
  onNavigate?: () => void;
}) {
  const location = useLocation();
  const links = useHomeNavigationLinks();

  return (
    <div
      className={cn(
        "grid rounded-xl border border-slate-200 bg-slate-100 p-1 dark:border-slate-700 dark:bg-slate-800",
        mobile
          ? links.length > 1
            ? "mb-5 grid-cols-2"
            : "mb-5 grid-cols-1"
          : "grid-flow-col",
      )}>
      {links.map(link => {
        const Icon = link.icon;
        const isActive =
          link.to === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(link.to);

        return (
          <Link
            key={link.to}
            to={link.to}
            onClick={onNavigate}
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-black transition",
              isActive
                ? "bg-white text-violet-700 shadow-sm dark:bg-slate-950 dark:text-violet-300"
                : "text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white",
            )}>
            <Icon className="h-4 w-4" />
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
